const ORDER_ALERTS_TYPES = {
  ShipTogether: ['shiptogether', 'alerts'],
};

export const getViewNameFromOrderAlertType = (alertType) => ORDER_ALERTS_TYPES[alertType];
